class SelectVariant extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
  }
  connectedCallback() {
    this.select.addEventListener("change", function () {
      const selectedOption = this.value;
      window.location.href = selectedOption;
    });
  }
}
window.customElements.define("select-variant", SelectVariant);
